import React from 'react';
import { Outlet, Route } from 'react-router';
import MainLayout from 'app/components/layouts/MainLayout';
import AvailabilityDetailsPageRoute from './AvailabilityDetailsPageRoute';

const basePath = '/v2/availability/:metadataId';

// The layout is a v6 layout route: it renders <Outlet />, which the matched child fills. MainLayout
// itself is unchanged -- it still just renders its children, and <Outlet /> is one of them.
export default (
  <Route
    path={basePath}
    element={
      <MainLayout deprecated>
        <Outlet />
      </MainLayout>
    }
  >
    <Route index element={<AvailabilityDetailsPageRoute />} />
  </Route>
);
